<template>
    <div id="layout">
        <x-header class="l-header"></x-header>
        <x-content class="l-content"></x-content>
        <x-footer class="l-footer"></x-footer>

    </div>
</template>

<script>
    import './common/css/init.css'
    import './common/js/setviewport'
    import xHeader from './components/header/header.vue'
    import xContent from './components/content/content.vue'
    import xFooter from './components/footer/footer.vue'
    export default {
        components: {
            'xHeader': xHeader,
            'xContent': xContent,
            'xFooter': xFooter
        }
    }
</script>

<style>
    #layout{width: 100%; height: 100%;}
    .l-content{}
    .l-footer{margin-top: 100px;}
    .l-header{}
</style>



// WEBPACK FOOTER //
// src/layout.vue